import { FC, useCallback, useMemo } from 'react'

import { CrudModal, WorkOrderForm, workOrderValuesToWorkOrderAddUpsert, IWorkOrderValues } from '../../../components'
import { useCreateWorkOrderOnHazardMutation } from '../../../services'
import { useProfile } from '../../../security'

import { ISafetyCaseHazard } from '../../../interfaces'

type CreateMitigationWorkOrderModalProps = {
  isOpen: boolean
  closeModal: () => void
  hazard?: ISafetyCaseHazard
  onSuccessCallback?: () => void
}

const CreateMitigationWorkOrderModal: FC<CreateMitigationWorkOrderModalProps> = props => {
  const { isOpen, closeModal, hazard, onSuccessCallback } = props

  const { airportId } = useProfile()

  const onWorkOrderTypeChangeMutator = useCallback((args: any, state: any, mutate: any) => {
    const workOrderTypeId = args?.[0]

    mutate.changeValue(state, 'workOrderTypeId', () => workOrderTypeId)

    mutate.changeValue(state, 'safetyItem.facilityId', () => undefined)
    mutate.changeValue(state, 'safetyItem.conditionId', () => undefined)
    mutate.changeValue(state, 'safetyItem.safetyItemUniqueValueId', () => undefined)
    mutate.changeValue(state, 'safetyItem.safetyItemResponseId', () => undefined)
  }, [])

  const onFacilityChangeMutator = useCallback((args: any, state: any, mutate: any) => {
    const facilityId = args?.[0]

    mutate.changeValue(state, 'safetyItem.facilityId', () => facilityId)

    mutate.changeValue(state, 'safetyItem.conditionId', () => undefined)
  }, [])

  const mutators = useMemo(
    () => ({
      onWorkOrderTypeChange: onWorkOrderTypeChangeMutator,
      onFacilityChange: onFacilityChangeMutator,
    }),
    [onWorkOrderTypeChangeMutator, onFacilityChangeMutator],
  )

  return (
    <CrudModal
      modalSettings={{
        isOpen,
        closeModal,
        mode: isOpen ? 'create' : undefined,
      }}
      createSettings={{
        title: 'Mitigation Work Order',
        useCreateMutation: useCreateWorkOrderOnHazardMutation,
        formValuesToAddUpsert: (workOrderValues: IWorkOrderValues) => {
          const workOrderAddUpsert = workOrderValuesToWorkOrderAddUpsert(workOrderValues, {
            airportId,
            safetyCaseGeoJson: hazard?.geoJson,
            safetyCaseLocation: hazard?.location,
          })

          return workOrderAddUpsert && hazard ? { ...workOrderAddUpsert, hazardId: hazard.id } : undefined
        },
        onCreateSuccessMessage: 'Mitigation work order successfully created',
        onCreateErrorMessage: 'Something went wrong while creating the mitigation work order',
        onSuccessCallback,
      }}
      FormComponent={WorkOrderForm}
      formName="mitigation-work-order"
      mutators={mutators}
    />
  )
}

export default CreateMitigationWorkOrderModal
